import {getPageBranch, getBranches} from '../../api/endpoints/branches'

export const state = {
  data: [],
  currentPage: 1,
  rows: 1,
  perPage: 1,
}

export const getters = {
  tableData: state => state.data,
  id: state => state.id,
  currentPage: state => state.currentPage,
  rows: state => state.rows,
  perPage: state => state.perPage,
}

export const mutations = {
  ON_FETCH(state) {
    getPageBranch(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  GET_PAGE(state, id) {
    state.currentPage = id;
    getPageBranch(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  GET_TOTAL_ROWS(state) {
    getBranches().then( res => {
      state.rows = res.data.total;
    })
  },
  GET_PER_PAGE(state) {
    getBranches().then( res => {
      state.perPage = res.data.per_page;
    })
  },
}

export const actions = {
  onFetch({commit}) {
    commit('ON_FETCH');
  },
  getPage({commit}, params) {
    commit('GET_PAGE', params)
  },
  getTotalRow({commit}) {
    commit('GET_TOTAL_ROWS')
  },
  getPerPage({commit}) {
    commit('GET_PER_PAGE')
  },
}